import React from 'react';

const NoMatch = () => {
    return (
        <div className="text-center text-danger">
            <h1>Page not found</h1>
            <h2>404, Error</h2>
        </div>
    );
};

export default NoMatch;